/**
 * @flow
 */
import {combineReducers} from "redux";
import LayoutReducer from "./LayoutReducer";
import notificationReducer from "./notificationReducer";
import signInReducer from "./signInReducer";
import signUpReducer from './signUpReducer';
import userReducer from "./userReducer";
import breadcrumbReducer from './breadcrumbReducer';
import {
  activityLogReducer, badDataLogReducer,
  branchDataReducer,
  companyDataReducer, dashboardListReducer, dashboardNotiReducer, demoRequestsReducer,
  deviceDataReducer,
  deviceTypeDataReducer, errorLogReducer,
  groupDataReducer, loginLogReducer, notificationDataReducer,
  userDataReducer, connectDataReducer, dashboardPatientsListReducer
} from './dataReducers';
import {sharedDataReducer} from './sharedDataReducers'
import {modalReducer} from './modalReducer';

// store에 들어가는 state들을 모아준다.
// useSelector를 사용하여 해당명(ex. companies)을 파라미터로 넘겨주면 해당하는 state를 가지고 올 수 있다.
const rootReducer = combineReducers({
  user: userReducer,
  breadcrumb: breadcrumbReducer,
  layout: LayoutReducer,
  notification: notificationReducer,
  signIn: signInReducer,
  signUp: signUpReducer,
  modal: modalReducer,
  companies: companyDataReducer,
  branches: branchDataReducer,
  groups: groupDataReducer,
  users: userDataReducer,
  devices: deviceDataReducer,
  deviceTypes: deviceTypeDataReducer,
  connect: connectDataReducer,
  dashboardList: dashboardListReducer,
  dashboardPatientsList: dashboardPatientsListReducer,
  dashboardNoti: dashboardNotiReducer,
  sharedData: sharedDataReducer,
  notificationData: notificationDataReducer, // 관리자가 보는 알림 목록 (읽기/쓰기)
  activityLog: activityLogReducer, // 액티비티 로그 목록
  loginLog: loginLogReducer, // 로그인 로그 목록
  badDataLog: badDataLogReducer, // 배드 데이터 로그 목록
  errorLog: errorLogReducer, // 에러 로그 목록 (수퍼어드민만 가능)
  demoRequests: demoRequestsReducer, // 데모 요청 (수퍼어드민만 가능)
});

export default rootReducer;
